/**
 * Hide Python/parse internals from tailoring agent UI (second line of defense after API).
 */

const USER_SAFE_JSON_FAILURE =
  'We could not apply AI suggestions for this section after automatic retry. Try running optimization again or edit this section manually.'

const USER_SAFE_INTERNAL =
  'Something went wrong while tailoring this section. Try running optimization again.'

const USER_SAFE_LLM_UNAVAILABLE =
  'The AI service was temporarily unavailable. Please try again in a moment.'

const TECHNICAL_PATTERNS: Array<{ pattern: RegExp; message: string }> = [
  { pattern: /unbalanced json/i, message: USER_SAFE_JSON_FAILURE },
  { pattern: /no json object/i, message: USER_SAFE_JSON_FAILURE },
  { pattern: /jsondecodeerror/i, message: USER_SAFE_JSON_FAILURE },
  { pattern: /'list' object has no attribute/i, message: USER_SAFE_INTERNAL },
  { pattern: /'dict' object has no attribute/i, message: USER_SAFE_INTERNAL },
  { pattern: /has no attribute 'get'/i, message: USER_SAFE_INTERNAL },
  { pattern: /object is not subscriptable/i, message: USER_SAFE_INTERNAL },
  { pattern: /typeerror:/i, message: USER_SAFE_INTERNAL },
  { pattern: /attributeerror:/i, message: USER_SAFE_INTERNAL },
  { pattern: /anthropic api error/i, message: USER_SAFE_LLM_UNAVAILABLE },
  { pattern: /openai api error/i, message: USER_SAFE_LLM_UNAVAILABLE },
]

export function sanitizeOptimizationUserMessage(
  message: string | null | undefined,
  fallback = USER_SAFE_INTERNAL
): string {
  const text = (message ?? '').trim()
  if (!text) return fallback
  for (const { pattern, message: friendly } of TECHNICAL_PATTERNS) {
    if (pattern.test(text)) return friendly
  }
  if (/traceback/i.test(text) || /file "/i.test(text)) return USER_SAFE_INTERNAL
  return text
}
